import React, { useState, useEffect, useRef } from 'react';
import { DayPilot, DayPilotMonth } from "@daypilot/daypilot-lite-react";

const HOLIDAY_COLOR = "#FFA500";
const today = DayPilot.Date.today();

export const MonthEvents = ({startDate=today,eventsData,onEventSelected}) => {
  const [events, setEvents] = useState([]);
  const [holidays, setHolidays] = useState(new Map());
  const calendarRef = useRef(null);

const holidaysCache = useRef(new Map()); // { year -> Map<date, name> }

useEffect(() => {
  const year = new DayPilot.Date(startDate).getYear();
  if (holidaysCache.current.has(year)) {
    setHolidays(holidaysCache.current.get(year));
    return;
  }
  fetch(`https://date.nager.at/api/v3/PublicHolidays/${year}/US`)
    .then(res => res.json())
    .then(data => {
      const map = new Map(data.map(h => [h.date, h.localName]));
      holidaysCache.current.set(year, map);
      setHolidays(map);
    })
    .catch(() => setHolidays(new Map()));
}, [startDate]);


  useEffect(() => {
    setEvents(eventsData);
  }, [eventsData]);

  const getHoliday = (date) => {
    if (!date) return null;
    const dateStr = date.toString("yyyy-MM-dd");
    if (!holidays.has(dateStr)) return null;
    return { color: HOLIDAY_COLOR, name: holidays.get(dateStr) };
  };
  return (
    <DayPilotMonth
      startDate={startDate}
      events={events}
      controlRef={calendarRef}
      onEventClick={(event)=>{
        onEventSelected(event.e.data);
      }}

       onBeforeCellRender={(args) => {
        const holiday = getHoliday(args.cell.start);
        if (holiday) {
          args.cell.properties.backColor = holiday.color;
          args.cell.properties.html = `<div style="font-size:11px;color:#fff;padding:2px 4px;font-weight:600;">${holiday.name}</div>`;
        }
      }}

      eventBarVisible={false}
      cellHeight={60}
      weekStarts={1}
      eventHeight={30}
      eventBorderRadius={8}
    />
  );
};